import { TypePolicy } from '@apollo/client';

const PatientNoteTypePolicy: TypePolicy = {
  keyFields: ['patientProblemId'],
};

export default PatientNoteTypePolicy;
